import { TermComponent } from './term/term.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { AupComponent } from './aup/aup.component';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { OfflineComponentsModule } from 'src/app/components/general/offline/offline.components.module';

@NgModule({
    declarations: [
        PrivacyComponent,
        TermComponent,
        AupComponent,
    ],
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        OfflineComponentsModule,
        TranslateModule
    ],
    exports: [
        PrivacyComponent,
        TermComponent,
        AupComponent,
    ]
})
export class AboutComponentsModule { }
